import { ComplexValue } from 'app/types-shared';
import { BowtieCaseOtherConnection, DraftConnections } from '../types';

export const getConnectionTypesList = (
  activeElementCaseNumber: number,
  otherConnections: BowtieCaseOtherConnection[],
  draftConnections: DraftConnections[]
): ComplexValue<number>[] => {
  const flatList = [
    ...(otherConnections
      ?.filter(other => other.caseId === activeElementCaseNumber)
      ?.map(other => other.connectionType)
      ?.filter(connectionType => connectionType) ?? []),
    ...(draftConnections
      ?.filter(draft => draft.caseNumber === activeElementCaseNumber)
      ?.map(draft => draft.connections ?? [])
      ?.filter(connectionType => connectionType)
      ?.reduce((result, value) => [...result, ...value], []) ?? [])
  ];

  return flatList.reduce(
    (result, value) => result.some(r => r.value === value.value)
      ? result
      : [...result, value],
    []
  );
};
